
import HeartCrack from '../../../assets/svg/HeartCrack';
import Button from '../../../components/Button/Button';
import { ApplicationStatus } from '../../../domain/types';
import useComponentTracker from '../../../hooks/useComponentTracker';
import useTranslation from '../../../hooks/useTranslation';
import StatusPage from '../StatusPage';

type DeclineReason = 'INTERNAL_CREDIT_SCORING' | 'PAYMENT_REMARK' | 'BLOCKED' | 'OTHER_EXTERNAL_DATA' | 'OTHER';
export type DeclineReasons = DeclineReason[];

type Props = {
    reason: DeclineReason;
};

const StatusDeclinedPage = ({ reason }: Props) => {
    useComponentTracker('StatusDeclinedPage', ApplicationStatus.declined);
    const translate = useTranslation();

    let body = translate('page.status-declined.body.generic');
    if (reason === 'INTERNAL_CREDIT_SCORING') {
        body = translate('page.status-declined.body.internal-credit-scoring');
    } else if (reason === 'PAYMENT_REMARK') {
        body = translate('page.status-declined.body.payment-remark');
    } else if (reason === 'BLOCKED') {
        body = translate('page.status-declined.body.blocked');
    } else if (reason === 'OTHER_EXTERNAL_DATA') {
        body = translate('page.status-declined.body.other-external-data');
    }

    return (
        <>
            <StatusPage
                icon={<HeartCrack />}
                title={translate('page.status-declined.title')}
                body={body}
                button={
                    <Button onClick={() => window.location.assign(translate('page.status-declined.button.start.url'))}>
                        {translate('page.status-declined.button.start.title')}
                    </Button>
                }
            />
        </>
    );
};

export default StatusDeclinedPage;
